import { Route } from 'src/routes/Route'

export const TrainingRoute = Route({
  path: '/training-schedule',
  hideTopBar: false,
})
export type TrainingRoute = Route<typeof TrainingRoute>
